<div>
	<p class="p mb-2">{{ modalData.subTitle }}</p>
	<p class="p-sm text-gray-500">{{ modalData.message }}</p>
</div>
